import agents from './agents'

export default {
    agents
}
